const menuRoutes = [
	//{ path: "/", name: "Home", ttoken: "menu.home", icon: "home" },
	{ path: "/", name: "map", ttoken: "menu.map", icon: "map" }
];

export default menuRoutes;